/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postDirection?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetType?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    routeId?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    floor?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    buildingId?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    occupancy?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    region1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): boolean {
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'streetNumber': json['streetNumber'] == null ? undefined : json['streetNumber'],
        'streetName': json['streetName'] == null ? undefined : json['streetName'],
        'postDirection': json['postDirection'] == null ? undefined : json['postDirection'],
        'streetType': json['streetType'] == null ? undefined : json['streetType'],
        'routeId': json['routeId'] == null ? undefined : json['routeId'],
        'floor': json['floor'] == null ? undefined : json['floor'],
        'buildingId': json['buildingId'] == null ? undefined : json['buildingId'],
        'occupancy': json['occupancy'] == null ? undefined : json['occupancy'],
        'region1': json['region1'] == null ? undefined : json['region1'],
        'city': json['city'] == null ? undefined : json['city'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'streetNumber': value['streetNumber'],
        'streetName': value['streetName'],
        'postDirection': value['postDirection'],
        'streetType': value['streetType'],
        'routeId': value['routeId'],
        'floor': value['floor'],
        'buildingId': value['buildingId'],
        'occupancy': value['occupancy'],
        'region1': value['region1'],
        'city': value['city'],
        'postalCode': value['postalCode'],
        'country': value['country'],
    };
}

